import { gql } from "@apollo/client";

const BACKFILL_MUTATION = gql`
  mutation backfill($name: String!, $since: DateTime!, $until: DateTime!) {
    backfill_source_bundle(name: $name, since: $since, until: $until) {
      ok
      handles
    }
  }
`;

const LAUNCH_BACKFILL_MUTATION = gql`
  mutation launch_backfill(
    $upload_names: [String!]!
    $title: String!
    $description: String!
    $start_datetime: DateTime!
    $end_datetime: DateTime!
  ) {
    launch_backfill(
      backfill: {
        upload_names: $upload_names
        title: $title
        description: $description
        start_datetime: $start_datetime
        end_datetime: $end_datetime
      }
    ) {
      __typename
      ... on Backfill {
        id
        status
        created_by {
          name
          email
        }
        cancelled_by {
          name
          email
        }
        start_datetime
        end_datetime
        changelist {
          id
        }
        subgraph {
          id
        }
        upload_names
        download_names
        title
        description
        total_pipelines
        succeeded_pipelines
        failed_pipelines
      }
      ... on ConflictingBackfillsError {
        conflicting_backfills {
          id
          title
        }
      }
    }
  }
`;

const SAVE_BACKFILL_MUTATION = gql`
  mutation save_backfill($backfill_id: String!, $status: String, $title: String, $description: String) {
    save_backfill(backfill_id: $backfill_id, backfill: { status: $status, title: $title, description: $description }) {
      id
      status
      title
      description
    }
  }
`;

export { BACKFILL_MUTATION, LAUNCH_BACKFILL_MUTATION, SAVE_BACKFILL_MUTATION };
